import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl } from '../common/base-list.component';
import { GlobalConstants } from '../common/GlobalConstants ';
import { ServiceLocatorService } from '../common/service/service-locator.service';

@Component({
  selector: 'app-gate-list',
  templateUrl: './gate-list.component.html',
  styleUrls: ['./gate-list.component.css']
})

export class GateListComponent extends BaseListCtl {

  constructor(public locator: ServiceLocatorService, public route: ActivatedRoute) {
    super(locator.endpoints.GATE, locator, route);  
  }

  public sid = localStorage.getItem( GlobalConstants.getKey('sessionId'));

  populateForm(form, data) {
    form.id = data.id;
    form.name = data.name;
    form.qrCode = data.qrCode;
    form.unitId = data.unitId;
    form.unitName = data.unitName;
    form.wifiId = data.wifiId;
    form.wifiName = data.wifiName;
    form.userId = data.userId;
    form.userName = data.userName;
    form.hotspot = data.hotspot;
    form.macId = data.macId;
    form.bluetooth = data.bluetooth;
    form.latitude = data.latitude;
    form.longitude = data.longitude;
    form.mobileId = data.mobileId;
    form.isAccess = data.isAccess;
    form.isWifi = data.isWifi;
    form.accessRequest = data.accessRequest;
    form.gateType=data.gateType;
    form.status = data.status;  
    console.log('----->', data);
  }
 
  getQRCodeHref(qrCode){
    if(qrCode){
      qrCode = qrCode.trim();
    }
    let url = "https://nenosystems.in/PNAC/Gate/qrcode/" + qrCode +';jsessionid='+ this.sid
    return url;
  }
}